/*
创建者 魏强(2018.1.30)
右侧商品
*/
<template>
  <div class="squares" style="text-align:left;">
    <ul class="list_pic clearfix">
      <li v-handle-hover class="item" v-for="item in data" :key="item.goods_id">
        <div class="goods-content">
          <div class="goods-pic">
            <router-link :to="{path:'/goods',query:{goods_id:item.goods_id}}" target="_blank">
              <img :src="item.thumbnail" :alt="htmlFiler(item.name)" />
            </router-link>
          </div>
          <div class="goods-info">
            <div class="goods-pic-scroll-show">
              <div class="ul">
                <img :src="item.thumbnail" height="28" width="28" border="0" style="vertical-align: middle">
                <img v-if="item.store_id==1 && parseInt(item.source_flag)!=2" src="//static.kxymall.com/images/gdzy.png" width="44" height="16" style="width:44px;height:16px;border:0;vertical-align:middle;margin-right:3px;" title="开心自营，品质保障" />
                <img v-if="item.store_id==1 && parseInt(item.source_flag)==2" src="//images.kxymall.com/gdzg.png" width="44" height="16" style="width:44px;height:16px;border:0;vertical-align:middle;margin-right:3px;" title="开心自营，品质保障" />
                <label v-if="item.goods_transfee_charge==1" style="background-color:red;color:white;vertical-align:middle;">包邮</label>
              </div>
            </div>
            <div class="goods-name">
              <router-link :to="{path:'/goods',query:{goods_id:item.goods_id}}" target="_blank">
                <span v-html="item.name"></span>
              </router-link>
            </div>
            <div class="goods-price" v-if="goodsType==='batch'">
              <span style="float: left;">批发价：</span>
              <em class="sale-price" :title="'原价：¥'+item.mktprice">¥{{item.price}}</em>
              <span style="float: left;margin-left:20px;">会员价：</span>
              <span style="text-decoration:line-through;">¥{{item.batch_price}}</span>
            </div>
            <div class="goods-price" v-if="getGoodsType==='chain'">
              <em class="sale-price" :title="'原价：¥'+item.mktprice">¥{{item.price}}</em>
              <span v-if="parseInt(item.source_flag)===2 && item.coupon_amount_by_chain > 0" style="float: left;margin-left:20px;">现金券抵扣：</span>
              <span v-if="parseInt(item.source_flag)===2 && item.coupon_amount_by_chain > 0">¥{{item.coupon_amount_by_chain}}</span>
            </div>
            <div v-if="goodsType!='batch' && getGoodsType!='chain'" class="goods-price">
              <em class="sale-price" :title="'原价：¥'+item.mktprice">¥{{item.price}}</em>
              <span v-if="parseInt(item.vouchers_status)===2 " style="float: left;margin-left:20px;">现金券抵扣：</span>
              <span v-if="parseInt(item.vouchers_status)===2">¥{{item.vouchers_coupon_amout}}</span>
              <span v-if="parseInt(item.source_flag)===4 && item.subsidyPoint>0" style="float: left;margin-left:20px;">补助积分：</span>
              <span v-if="parseInt(item.source_flag)===4 && item.subsidyPoint>0">{{item.subsidyPoint}}</span>
            </div>
            <div class="sell-stat">
              <ul>
                <li>
                  <a href="javascript:void(0)" onclick="return false;" class="status">{{item.buy_num}}</a>
                  <p>商品销量</p>
                </li>
                <li>
                  <a href="javascript:void(0)" onclick="return false;">{{item.comment_num}}</a>
                  <p>用户评论</p>
                </li>
              </ul>
            </div>
            <div class="store">
              <router-link :to="{path:'/shop',query:{store_id:item.store_id,tab:1}}" target="_blank">
                店铺：{{item.store_name}}
              </router-link>
            </div>
            <div class="add-cart" v-if="goodsType==='batch'">
              <span>起批量：{{item.batch_amount}}</span>
              <router-link :to="{path:'/goods',query:{goods_id:item.ori_goods_id}}" target="_blank">点击查看原商品
              </router-link>
            </div>
            <div class="add-cart" v-else>
              <a @click.stop.prevent="cAddCart(item)" class="add_cart">
                加入购物车
              </a>
              <a @click.stop.prevent="buynow(item)" class="buynow">
                立即购买
              </a>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { cartBuy } from 'api/goodsCart'
import { mapGetters } from "vuex"
export default {
  props: ["data"],
  directives: {
    handleHover(el) {
      $(el).hover(
        function () {
          $(el).find(".goods-info").animate({ "top": "150px" }, 400, "swing");
        }, function () {
          $(el).find(".goods-info").stop(true, false).animate({ "top": "230px" }, 400, "swing");
        });
    }
  },
  computed: {
    ...mapGetters([
      "sid"
    ]),
    // 计算是否已登陆
    isLogin() {
      return this.sid && this.sid.length > 0 ? true : false;
    },
    goodsType() {
      return this.$route.query.goodsType
    },
    getGoodsType() {
      if (this.$route.path == '/supply-chain-list') {
        return 'chain';
      }
    }
  },
  methods: {
    buynow(item) {
      if (this.isLogin) {
        let minNum = item.min_buy_num > 1 ? item.min_buy_num : 1
        cartBuy({
          buyFlag: 1,
          goodsId: item.goods_id,
          goodsNum: minNum
        }).then(res => {
          if (item.source_flag == '1') {
            this.$router.push({
              path: '/checkout',
              query: {
                storeId: item.store_id,
                num: minNum,
                goodsId: item.goods_id,
                source_flag: item.source_flag,
                coupon: res.data.coupon,
                chainGoodsProfit: res.data.chainGoodsProfit,
                checkAtTheShoppingPv: res.data.checkAtTheShoppingPv,
                couponLimit: res.data.checkAtTheCoupon,
                selfShoppingPv: res.data.selfShoppingPv
              }
            })
          } else if (item.source_flag == '2' || (this.goods && this.goods.source_flag == '3')) {
            this.$router.push({
              path: '/checkout',
              query: {
                storeId: item.store_id,
                num: minNum,
                goodsId: item.goods_id,
                coupon: res.data.coupon,
                source_flag: item.source_flag,
                chainGoodsProfit: res.data.chainGoodsProfit,
                checkAtTheShoppingPv: res.data.checkAtTheShoppingPv,
                couponLimit: res.data.checkAtTheCoupon,
                selfShoppingPv: res.data.selfShoppingPv
              }
            })
          } else {
            this.$router.push({
              path: '/checkout',
              query: {
                storeId: item.store_id,
                num: minNum,
                goodsId: item.goods_id,
                coupon: res.data.coupon,
                chainGoodsProfit: res.data.chainGoodsProfit,
                checkAtTheShoppingPv: res.data.checkAtTheShoppingPv,
                couponLimit: res.data.checkAtTheCoupon,
                selfShoppingPv: res.data.selfShoppingPv
              }
            })
          }
        })
      } else {
        this.$Modal.confirm({
          title: '温馨提示',
          content: '<p>您当前是游客身份，游客身份不能购买商品！</p>',
          okText: "马上登录",
          onOk: () => {
            document.cookie = "loginReferrer=" + escape(location.href.split(location.host)[1]) + "; path=/";
            this.$router.push('/login');
          },
          cancelText: "取消",
          onCancel: () => {
          }
        });
      }
    },
    htmlFiler(str) {
      return str.replace(/<\/?[^>]*>/g, '')
    },
    // 添加购物车
    cAddCart(item) {
      if (this.isLogin) {
        this.$store.dispatch('addCart', {
          id: item.goods_id,
          num: item.min_buy_num > 1 ? item.min_buy_num : 1
        }).then(res => {
          if (res.resCode === 1) {
            this.$Message.info('成功加入购物车');
          } else {
            this.$Message.info(res.resDesc);
          }
        })
      } else {
        this.$Modal.confirm({
          title: '温馨提示',
          content: '<p>您当前是游客身份，游客身份不能加入购物车！</p>',
          okText: "马上登录",
          onOk: () => {
            document.cookie = "loginReferrer=" + escape(location.href.split(location.host)[1]) + "; path=/";
            this.$router.push('/login');
          },
          cancelText: "取消",
          onCancel: () => {
          }
        });
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// module-right-goods.vue?2fbad339